import React from "react";
import {
  Table,
  TableRow,
  TableCell,
  TableHeader,
} from "carbon-react/lib/components/table";
import Spinner from "carbon-react/lib/components/loader";
import AgentStatusPill from "./AgentStatusPill";
import { getAgentRoleDisplayValue } from "../../constants/model";
import AgentPopOverContextMenu from "./AgentPopOverContextMenu";
import TableHeaderWithSortIndicator, {
  sortOrder,
} from "../common/tableHeaderWithSortIndicator/TableHeaderWithSortIndicator";
import SimpleTablePager from "../common/simpleTablePager/SimpleTablePager";

const AgentTable = ({
  agentResultSet,
  loading,
  onAgentUpdated,
  onAgentRemoved,
  onOpenCommentsDialog,
  onOpenChangeRoleDialog,
  onPagePrev,
  onPageNext,
  pageNo,
  lastPage,
}) => {
  const agents = agentResultSet?.agents || [];

  const tableRows = agents.map((agent, key) => {
    return (
      <TableRow id={`agents-table-row-${key}`} key={agent.id}>
        <TableCell id={`agents-table-cell-id-${key}`}>{agent.id}</TableCell>
        <TableCell id={`agents-table-cell-email-${key}`}>
          {agent.email}
        </TableCell>
        <TableCell id={`agents-table-cell-status-${key}`}>
          <AgentStatusPill agent={agent} />
        </TableCell>
        <TableCell id={`agents-table-cell-role-${key}`}>
          {getAgentRoleDisplayValue(agent.role)}
        </TableCell>
        <TableCell id={`agents-table-cell-actions-${key}`}>
          <AgentPopOverContextMenu
            agent={agent}
            onAgentUpdated={onAgentUpdated}
            onAgentRemoved={onAgentRemoved}
            onOpenCommentsDialog={onOpenCommentsDialog}
            onOpenChangeRoleDialog={onOpenChangeRoleDialog}
          />
        </TableCell>
      </TableRow>
    );
  });

  const tableHeader = (
    <TableRow>
      <TableHeader id="agents-table-header-id">Id</TableHeader>
      <TableHeaderWithSortIndicator
        id="agents-table-header-email"
        sortOrder={sortOrder.asc}
      >
        Email address
      </TableHeaderWithSortIndicator>
      <TableHeader id="agents-table-header-status">Status</TableHeader>
      <TableHeader id="agents-table-header-role">Role</TableHeader>
      <TableHeader />
    </TableRow>
  );

  const gridSpinner = (
    <TableRow
      key="__loading__"
      selectable={false}
      highlightable={false}
      hideMultiSelect
    >
      <TableCell colSpan="100" align="center">
        <Spinner size="small" />
      </TableCell>
    </TableRow>
  );

  return (
    <div className="agents-table">
      <Table isZebra thead={tableHeader} shrink>
        {loading === true ? gridSpinner : tableRows}
      </Table>
      <SimpleTablePager
        appearBusy={loading}
        pageNo={pageNo}
        lastPage={lastPage}
        onPagePrev={onPagePrev}
        onPageNext={onPageNext}
      />
    </div>
  );
};

export default AgentTable;
